import React from "react";
import "./Tags.css";

const Tags = ({ tags }) => {

    const getTagColorClass = (index) => {
        if (index % 3 === 0) {
            return 'purple';
        } else if (index % 3 === 1) {
            return 'red';
        } else {
            return 'green';
        }
    };

    return (
        <div className="tag-list">
            {tags.map((tag, index) => (
                <span className={`tag-list__item tag-list__item__` + getTagColorClass(index)}>
                    {tag.name}
                </span>
            ))}
        </div>
    );
};

export default Tags;